/* eslint-disable no-useless-rename */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable array-callback-return */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { cloneDeep } from 'lodash';
import { Button, Form, FormGroup } from 'react-bootstrap';
import { PageMessage } from 'components/GlobalUI';
import {
  WebThemeTarget as ThemeTarget,
  WebThemeMethod as ThemeMethod,
  MessageType,
} from '@upstart/harmony/lib/legos/websiteTypes';
import websiteActions from '../../../redux/websites/actions';
import dealerActions from '../../../redux/dealers/actions';
import ColorPicker from '../WebsiteWidgetConfigEditor/inputs/ColorPicker';
import Select from '../WebsiteWidgetConfigEditor/inputs/Select';
import LoadingOverlay from '../../LoadingOverlay';
import '../Website.scss';

const colorDefaultOverride = {
  colorPrimaryDark: '#1A6664',
  colorSuccessDark: '#409C64',
  colorErrorDark: '#D71974',
  colorInfoDark: '#0765F9',
};
const websiteDefaultOverrides = {
  ...colorDefaultOverride,
  btnBorderRadius: '8px',
  inputBorderRadius: '8px',
  radioBtnBorderRadius: '8px',
};
const dealerDefaultOverrides = {
  ...colorDefaultOverride,
};

const BTN_CORNER_RADIUS_KEY = 'btnBorderRadius';
const INPUT_CORNER_RADIUS_KEY = 'inputBorderRadius';
const RADIO_BTN_CORNER_RADIUS_KEY = 'radioBtnBorderRadius';
const BORDER_RADIUS_KEYS = [
  BTN_CORNER_RADIUS_KEY,
  INPUT_CORNER_RADIUS_KEY,
  RADIO_BTN_CORNER_RADIUS_KEY,
];
const COLOR_KEYS = [
  'colorPrimaryDark',
  'colorSuccessDark',
  'colorErrorDark',
  'colorInfoDark',
];
const overrideKeys = [...COLOR_KEYS, ...BORDER_RADIUS_KEYS];

const defaultFontFile = '---none---';
const defaultCustomTheme = '---none---';

enum CurrentTab {
  website = 'website',
  dealer = 'dealer',
}
function Theme(props: any) {
  const {
    website,
    actions,
    history,
    availableFonts,
    availableThemes,
    fetching,
    success,
    error,
    dealer,
    currentTab,
  } = props;
  const target = currentTab === CurrentTab.dealer ? dealer : website;
  const client = currentTab === CurrentTab.dealer ? 'instore' : 'web';
  const defaultOverride =
    currentTab === CurrentTab.dealer
      ? dealerDefaultOverrides
      : websiteDefaultOverrides;
  const [method, setMethod] = useState(
    target?.theme?.method || ThemeMethod.NONE,
  );
  const [errors, setErrors]: any = useState({});
  const [fontFile, setFontFile] = useState(
    target?.theme?.fontFile || defaultFontFile,
  );
  const [fontFileBold, setFontFileBold] = useState(
    target?.theme?.fontFileBold || defaultFontFile,
  );
  const [previewFontFile, setPreviewFontFile] = useState(
    target?.theme?.previewFontFile || defaultFontFile,
  );
  const [previewFontFileBold, setPreviewFontFileBold] = useState(
    target?.theme?.previewFontFileBold || defaultFontFile,
  );
  const [overrides, setOverrides] = useState(
    target?.theme?.overrides || defaultOverride,
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [previewOverrides, setPreviewOverrides] = useState(
    target?.theme?.previewOverrides ||
      target?.theme?.overrides ||
      defaultOverride,
  );

  const [displayOverrides, setDisplayOverrides] = useState(
    target?.theme?.overrides || defaultOverride,
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [customTheme, setCustomTheme] = useState(
    target?.theme?.customTheme || defaultCustomTheme,
  );

  const [displayCustomTheme, setDisplayCustomTheme] = useState(
    target?.theme?.customTheme || defaultCustomTheme,
  );

  const [previewMode, setPreviewMode] = useState(false);

  const [availableFontsDisplay, setAvailableFontsDisplay] = useState([]);
  const [availableThemesDisplay, setAvailableThemesDisplay] = useState([]);

  useEffect(() => {
    actions.availableThemesRequest({ client });
    actions.availableFontsRequest();
  }, [actions]);

  useEffect(() => {
    const copy = cloneDeep(availableFonts);
    copy.unshift({
      name: defaultFontFile,
    });
    setAvailableFontsDisplay(copy);
  }, [availableFonts]);

  useEffect(() => {
    const copy = cloneDeep(availableThemes);
    copy.unshift(defaultCustomTheme);
    setAvailableThemesDisplay(copy);
  }, [availableThemes]);

  useEffect(() => {
    if (target?.theme?.overrides) {
      setOverrides(target.theme.overrides);
      if (!previewMode) {
        setDisplayOverrides(target.theme.overrides);
      }
    }
    if (target?.theme?.previewOverrides) {
      setPreviewOverrides(target.theme.previewOverrides);
    }
    if (target?.theme?.method) {
      setMethod(target.theme.method);
    }
    if (target?.theme?.fontFile) {
      setFontFile(target.theme.fontFile);
    }
    if (target?.theme?.fontFileBold) {
      setFontFileBold(target.theme.fontFileBold);
    }
    if (target?.theme?.previewFontFile) {
      setPreviewFontFile(target.theme.previewFontFile);
    }
    if (target?.theme?.previewFontFileBold) {
      setPreviewFontFileBold(target.theme.previewFontFileBold);
    }
    if (target?.theme?.customTheme) {
      setCustomTheme(target.theme.customTheme);
      if (!previewMode) {
        setDisplayCustomTheme(target.theme.customTheme);
      }
    }
  }, [previewMode, target]);

  useEffect(() => {
    if (success) {
      PageMessage({
        message: `${
          previewMode
            ? 'Theme changes are ready to be previewed'
            : 'Theme changes successfully published'
        }`,
        type: MessageType.SUCCESS,
      });
    }
    if (error) {
      PageMessage({
        message: `Error setting website theme${
          error.message ? `: "${error.message}"` : ''
        }`,
        type: MessageType.ERROR,
      });
    }
  }, [success, error]);

  const isValidHexColor = (value: string) => {
    const validHexColorRegExp = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
    return validHexColorRegExp.test(value);
  };

  const validateForm = () => {
    const e: any = {};
    if (method === ThemeMethod.OVERRIDE) {
      const invalidOverrideHex = overrideKeys
        .filter((ov) => COLOR_KEYS.includes(ov))
        .some((ov) => {
          if (displayOverrides[ov] && !isValidHexColor(displayOverrides[ov])) {
            e[ov] = {
              message: 'Please Enter Valid Hex Code',
            };
            setErrors(e);
            return true;
          }
          return false;
        });
      if (invalidOverrideHex) {
        return false;
      }
    }

    setErrors(e);
    return true;
  };

  const cancel = () => {
    const path = currentTab === CurrentTab.dealer ? '/dealers/' : '/websites/';
    history.push(path);
  };

  const onColorChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const overridesCopy = cloneDeep(displayOverrides);
    if (!overrideKeys.includes(e?.target?.name)) {
      return;
    }

    overridesCopy[e.target.name] = e.target.value;
    setDisplayOverrides(overridesCopy);
  };

  const onFontChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFontFile(e.target.value);
  };

  const onFontBoldChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFontFileBold(e.target.value);
  };

  /**
   * The function handles the change event for a button corner radius input and updates the display
   * overrides accordingly.
   * For input fields and stylized radio buttons:
   * - Match button radius for 0-8px
   * - If button radius is > 8px, then radius should be 8px
   */
  const handleBtnCornerRadiusChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const overridesCopy = cloneDeep(displayOverrides);
    let btnCornerRadiusInPx = parseInt(e.target.value, 10);

    if (btnCornerRadiusInPx > 36) {
      btnCornerRadiusInPx = 36;
    }
    if (isNaN(btnCornerRadiusInPx)) {
      btnCornerRadiusInPx = 0;
    }
    overridesCopy.btnBorderRadius = `${Number(btnCornerRadiusInPx)}px`;

    const inputAndRadioBtnCornerRadiusInPx =
      btnCornerRadiusInPx > 8 ? 8 : btnCornerRadiusInPx;
    overridesCopy.inputBorderRadius = `${Number(
      inputAndRadioBtnCornerRadiusInPx,
    )}px`;
    overridesCopy.radioBtnBorderRadius = `${Number(
      inputAndRadioBtnCornerRadiusInPx,
    )}px`;
    setDisplayOverrides(overridesCopy);
  };

  const onCustomThemeChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setDisplayCustomTheme(e.target.value);
  };

  const processData = (targetData: ThemeTarget) => {
    const clonedTarget = cloneDeep(target);

    if (!clonedTarget.theme) {
      clonedTarget.theme = {};
    }

    clonedTarget.theme.method = method;

    // DEFAULT THEME
    if (method === ThemeMethod.NONE && targetData === ThemeTarget.PUBLIC) {
      clonedTarget.theme.overrides = null;
      clonedTarget.theme.previewOverrides = null;
      clonedTarget.theme.fontFile = null;
      clonedTarget.theme.fontFileBold = null;
      clonedTarget.theme.previewFontFile = null;
      clonedTarget.theme.previewFontFileBold = null;
      clonedTarget.theme.publicUrl = null;
      clonedTarget.theme.previewUrl = null;
      clonedTarget.theme.customTheme = null;
      clonedTarget.theme.previewCustomTheme = null;
    }

    // THEME OVERRIDES
    if (method === ThemeMethod.OVERRIDE) {
      if (targetData === ThemeTarget.PREVIEW) {
        // SET PREVIEW THEME OVERRIDES
        clonedTarget.theme.previewOverrides = displayOverrides;

        if (fontFile !== defaultFontFile) {
          clonedTarget.theme.previewFontFile = fontFile;
        } else {
          clonedTarget.theme.previewFontFile = null;
        }
        if (fontFileBold !== defaultFontFile) {
          clonedTarget.theme.previewFontFileBold = fontFileBold;
        } else {
          clonedTarget.theme.previewFontFileBold = null;
        }
      } else {
        // SET PUBLIC THEME OVERRIDES
        clonedTarget.theme.overrides = displayOverrides;
        clonedTarget.theme.previewOverrides = null;
        clonedTarget.theme.previewFontFile = null;

        if (fontFile !== defaultFontFile) {
          clonedTarget.theme.fontFile = fontFile;
        } else {
          clonedTarget.theme.fontFile = null;
        }
        if (fontFileBold !== defaultFontFile) {
          clonedTarget.theme.fontFileBold = fontFileBold;
        } else {
          clonedTarget.theme.fontFileBold = null;
        }
      }
    }

    // CUSTOM THEME
    if (method === ThemeMethod.CUSTOM) {
      clonedTarget.theme.overrides = null;
      clonedTarget.theme.previewOverrides = null;

      if (targetData === ThemeTarget.PREVIEW) {
        // SET PREVIEW CUSTOM THEME
        if (displayCustomTheme !== defaultCustomTheme) {
          clonedTarget.theme.previewCustomTheme = displayCustomTheme;
        } else {
          clonedTarget.theme.previewCustomTheme = null;
        }
      } else {
        // SET PUBLIC CUSTOM THEME
        clonedTarget.theme.previewCustomTheme = null;

        if (displayCustomTheme !== defaultCustomTheme) {
          clonedTarget.theme.customTheme = displayCustomTheme;
        } else {
          clonedTarget.theme.customTheme = null;
        }
      }
    }

    return clonedTarget;
  };

  const cancelPreview = () => {
    setPreviewOverrides(overrides);
    setPreviewMode(false);
  };

  const viewPreview = () => {
    const url =
      currentTab === CurrentTab.dealer
        ? `${process.env.REACT_APP_INSTORE_URL}?preview=true`
        : `${process.env.REACT_APP_WEB_URL}/browse/${website.id}?preview=true`;
    window.open(url);
  };

  const submitForm = (targetAction: ThemeTarget) => {
    if (validateForm()) {
      setPreviewMode(targetAction === ThemeTarget.PREVIEW);
      const newTarget = processData(targetAction);
      if (currentTab === CurrentTab.website) {
        actions.setWebsiteThemeRequest({
          website: newTarget,
          target: targetAction,
        });
      }
      if (currentTab === CurrentTab.dealer) {
        actions.setDealerThemeRequest({
          dealer,
          theme: newTarget.theme,
        });
      }
    }
  };

  return (
    <div className="website-tab-container">
      <div className="tab-main-content-container">
        <LoadingOverlay active={fetching}>
          <Form>
            <FormGroup>
              <div className="row">
                <div className="field col-sm-12">
                  <div className="horz-radio-container">
                    <label htmlFor="none">
                      No Custom Theme
                      <input
                        type="radio"
                        name="method"
                        id="none"
                        value={ThemeMethod.NONE}
                        checked={method === ThemeMethod.NONE}
                        onChange={(e) => setMethod('none')}
                      />
                    </label>
                    <label htmlFor="override">
                      Override Theme Values
                      <input
                        type="radio"
                        name="method"
                        id="override"
                        value={ThemeMethod.OVERRIDE}
                        checked={method === ThemeMethod.OVERRIDE}
                        onChange={(e) => setMethod('override')}
                      />
                    </label>
                    <label htmlFor="custom">
                      Custom Theme
                      <input
                        type="radio"
                        name="method"
                        id="custom"
                        value={ThemeMethod.CUSTOM}
                        checked={method === ThemeMethod.CUSTOM}
                        onChange={(e) => setMethod('custom')}
                      />
                    </label>
                  </div>
                </div>
              </div>
            </FormGroup>
            {method === ThemeMethod.NONE && <h3>Use Default Theme</h3>}
            {previewMode && (
              <div className="preview-mode-notice">
                You may preview your unpublished changes.
                <button type="button" onClick={() => viewPreview()}>
                  Preview Changes
                </button>
                &nbsp; Please publish changes below or cancel at right.
                <button type="button" onClick={() => cancelPreview()}>
                  Cancel Changes
                </button>
              </div>
            )}
            {method === ThemeMethod.OVERRIDE && (
              <FormGroup>
                <h3>Override Individual Theme Values</h3>
                <div className="row">
                  <div className="field col-sm-4">
                    <ColorPicker
                      name="colorPrimaryDark"
                      label="Primary Color"
                      formData={displayOverrides}
                      onChange={onColorChangeHandler}
                      error={errors?.colorPrimaryDark}
                    />
                  </div>
                  <div className="field col-sm-4">
                    <ColorPicker
                      name="colorSuccessDark"
                      label="Success Color"
                      formData={displayOverrides}
                      onChange={onColorChangeHandler}
                      error={errors?.colorSuccessDark}
                    />
                  </div>
                  <div className="field col-sm-4">
                    <ColorPicker
                      name="colorErrorDark"
                      label="Error Color"
                      formData={displayOverrides}
                      onChange={onColorChangeHandler}
                      error={errors?.colorErrorDark}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="field col-sm-4">
                    <ColorPicker
                      name="colorInfoDark"
                      label="Message Color"
                      formData={displayOverrides}
                      onChange={onColorChangeHandler}
                      error={errors?.colorInfoDark}
                    />
                  </div>
                  <div className="field col-sm-4">
                    <Select
                      label="Bold Font File"
                      name="fontFaceBoldPrimary"
                      value={previewMode ? previewFontFileBold : fontFileBold}
                      formData={{ fontFileBold }}
                      onChange={onFontBoldChangeHandler}
                      info="Only .ttf font is supported."
                    >
                      {availableFontsDisplay?.length > 0 &&
                        availableFontsDisplay.map((f: { name: string }) => (
                          <Select.Option
                            name={f.name}
                            value={f.name}
                            selected={f.name === fontFileBold}
                          />
                        ))}
                    </Select>
                  </div>
                  <div className="field col-sm-4">
                    <Select
                      label="Regular Font File"
                      name="fontFacePrimary"
                      value={previewMode ? previewFontFile : fontFile}
                      formData={{ fontFile }}
                      onChange={onFontChangeHandler}
                      info="Only .ttf font is supported."
                    >
                      {availableFontsDisplay.length > 0 &&
                        availableFontsDisplay.map((f: { name: string }) => (
                          <Select.Option
                            name={f.name}
                            value={f.name}
                            selected={f.name === fontFile}
                          />
                        ))}
                    </Select>
                  </div>
                  {currentTab === CurrentTab.website && (
                    <div className="field col-sm-4">
                      <label
                        className="widget-select-label"
                        htmlFor="btnCornerRadius"
                      >
                        <p>Button Corner Radius</p>
                        <input
                          type="number"
                          name="btnCornerRadius"
                          id="btnCornerRadius"
                          min="0"
                          max="36"
                          value={displayOverrides.btnBorderRadius?.replace(
                            'px',
                            '',
                          )}
                          onChange={handleBtnCornerRadiusChange}
                          style={{ textAlign: 'right', width: '46px' }}
                        />
                        px
                      </label>
                      <span className="widget-select-info info">
                        {'max 36px is supported.'}
                      </span>
                    </div>
                  )}
                </div>
              </FormGroup>
            )}
            {method === ThemeMethod.CUSTOM && (
              <div className="row">
                <div className="field col-sm-8">
                  <h3>Select a Custom Theme</h3>
                  <Select
                    label="Theme"
                    name="customTheme"
                    value={displayCustomTheme}
                    formData={{
                      displayCustomTheme,
                    }}
                    onChange={onCustomThemeChangeHandler}
                    error={errors.customTheme}
                  >
                    {availableThemesDisplay &&
                      availableThemesDisplay.length > 0 &&
                      availableThemesDisplay.map((t) => (
                        <Select.Option
                          name={t}
                          value={t}
                          selected={t === displayCustomTheme}
                        />
                      ))}
                  </Select>
                </div>
              </div>
            )}
          </Form>
        </LoadingOverlay>
      </div>
      <div className="row submit-button-row">
        <div>
          <Button
            className="btn btn-secondary"
            type="button"
            onClick={() => cancel()}
          >
            Cancel
          </Button>
        </div>
        <div>
          {method !== ThemeMethod.NONE && (
            <Button
              className="btn btn-primary"
              type="button"
              onClick={() => submitForm(ThemeTarget.PREVIEW)}
            >
              Preview
            </Button>
          )}
          <Button
            className="btn btn-primary"
            type="button"
            onClick={() => submitForm(ThemeTarget.PUBLIC)}
          >
            Publish
          </Button>
        </div>
      </div>
    </div>
  );
}

Theme.propTypes = {
  website: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
  dealer: PropTypes.object,
};

const mapStateToProps = (state: any) => ({
  availableFonts: state.websites.availableFonts,
  availableThemes: state.websites.availableThemes,
  fetching: state.websites.fetching || state.dealers.fetching,
  success: state.websites.success || state.dealers.success,
  error: state.websites.error || state.dealers.error,
});

const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  actions: bindActionCreators(
    {
      ...websiteActions,
      ...dealerActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Theme);
